import React from "react";
import { Image } from "react-bootstrap";

const ConvertSwapToken = ({
  title,
  coinName,
  coinImage,
  className,
  accountImg,
  inputValue,
  accountName,
}) => {
  return (
    <div className={`customInputField ${className}`}>
      <div className="top">
        <div className="left">
          {title && (
            <div className="inputHeading">
              <div className="name">{title}</div>
              <div className="account-tag">
                <Image src={accountImg} />
                {accountName}
              </div>
            </div>
          )}
          <p className="amount mb-0" style={{ overflow: "hidden" }}>
            {/* {userSwappedToken && isSignWallet
              ? parseInt(userSwappedToken).toLocaleString()
              : 0} */}
            {inputValue || 0}
          </p>
        </div>
        <div className="right swapWith">
          {coinName && (
            <div className="walletLogo">
              <div className="span wallet">
                <Image src={coinImage} fluid />
              </div>
              <span className="walletName">{coinName}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConvertSwapToken;
